var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 599.773,
    height: 459.201,
    viewBox: "0 0 599.773 459.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic",
    transform: "translate(-380.883 -440.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(-1696.293 -2809.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(2354.097 3249.869)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 216.904,
    height: 207.473,
    rx: 7.963,
    fill: "#333663"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 99.42,
    height: 6.02,
    rx: 2.39,
    transform: "translate(27.004 24.012)",
    fill: "#e1e9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 69.394,
    height: 6.02,
    rx: 2.39,
    transform: "translate(27.004 39.029)",
    fill: "#e1e9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 20.99,
    height: 4.299,
    rx: 1.707,
    transform: "translate(27.004 65.354)",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(40.124 115.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 57.949,
    height: 12.985,
    rx: 1.707,
    transform: "translate(0 79.504) rotate(-90)",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 79.504,
    height: 12.985,
    rx: 1.707,
    transform: "translate(23.605 79.504) rotate(-90)",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 57.949,
    height: 12.985,
    rx: 1.707,
    transform: "translate(52.032 79.504) rotate(-90)",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 79.504,
    height: 12.985,
    rx: 1.707,
    transform: "translate(75.637 79.504) rotate(-90)",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 42.239,
    height: 12.985,
    rx: 1.707,
    transform: "translate(104.064 79.503) rotate(-90)",
    fill: "#89aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 57.949,
    height: 12.985,
    rx: 1.707,
    transform: "translate(127.669 79.504) rotate(-90)",
    fill: "#91ffe7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(40.124 142.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 38.134,
    height: 12.985,
    rx: 1.707,
    transform: "translate(0 52.318) rotate(-90)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 52.318,
    height: 12.985,
    rx: 1.707,
    transform: "translate(23.605 52.318) rotate(-90)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 38.134,
    height: 12.985,
    rx: 1.707,
    transform: "translate(52.032 52.318) rotate(-90)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 52.318,
    height: 12.985,
    rx: 1.707,
    transform: "translate(75.637 52.318) rotate(-90)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 27.796,
    height: 12.985,
    rx: 1.707,
    transform: "translate(104.064 52.318) rotate(-90)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 38.134,
    height: 12.985,
    rx: 1.707,
    transform: "translate(127.669 52.318) rotate(-90)",
    fill: "#d2dcff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(2420.221 3396.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(38.778 85.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M2421.72,3529.56l12.9,106.954h4.231l-12.9-106.954Z",
    transform: "translate(-2364.71 -3409.375)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M2466.987,3529.559l1.451,12.029,11.449,94.926h4.232l-11.506-95.4-1.394-11.559Z",
    transform: "translate(-2352.967 -3409.375)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M2421.72,3636.514h4.231l1.784-14.792,2.115-17.539,6.959-57.69,2.042-16.934h-4.231l-2.1,17.418-4.784,39.665-2.115,17.539Z",
    transform: "translate(-2364.71 -3409.375)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M2376.453,3636.514h4.231L2390.7,3553.5h0l2.887-23.939h-4.231l-2.943,24.4Z",
    transform: "translate(-2376.453 -3409.375)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(56.32 48.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 4.232,
    height: 64.696,
    transform: "translate(57.494)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 4.231,
    height: 64.696,
    fill: "#d2dcff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M2385.986,3524.16h58.134a3.4,3.4,0,0,0-3.4,3.4h0a3.4,3.4,0,0,0,3.4,3.4h-58.134a3.4,3.4,0,0,1-3.4-3.4h0A3.4,3.4,0,0,1,2385.986,3524.16Z",
    transform: "translate(-2374.862 -3410.775)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M2428.745,3527.559h0a3.4,3.4,0,0,1,3.4-3.4h50.194a3.4,3.4,0,0,1,3.4,3.4h0a3.4,3.4,0,0,1-3.4,3.4h-50.194A3.4,3.4,0,0,1,2428.745,3527.559Z",
    transform: "translate(-2362.887 -3410.775)",
    fill: "#86a2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 78.117,
    height: 48.688,
    rx: 3.763,
    transform: "translate(48.124)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M2466.987,3529.559l1.451,12.028,4.175-.471-1.394-11.558Z",
    transform: "translate(-2352.967 -3409.375)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M2432.4,3529.559l-2.1,17.416,4.29-.483,2.043-16.933Z",
    transform: "translate(-2362.486 -3409.375)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M2384.359,3553.96q2.05-.219,4.287-.462h0l2.886-23.938H2387.3Z",
    transform: "translate(-2374.402 -3409.375)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M2471.055,3472.79h-4.231v8.936l4.231-.468Z",
    transform: "translate(-2353.01 -3424.102)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M2421.172,3472.79v15.3l4.231-.468V3472.79Z",
    transform: "translate(-2364.852 -3424.102)",
    fill: "#aec3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(70.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(1.536 18.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M2402.993,3395.373c1.571,19.058,15.414,31,23.538,31a15.073,15.073,0,0,0,3.932-.6v9.5h20.607v-24.166c.19-.5.376-1.054.557-1.646,9.136-.873,8.757-15.971,3.329-15.971-.987,0-1.649.933-2.063,1.874l-1.349,1.348V3389.9s-3.031.284-9-8.811c-2.575,3.906-23.118,10.042-39.6,7.294C2402.941,3388.385,2402.9,3391.777,2402.993,3395.373Z",
    transform: "translate(-2402.931 -3381.09)",
    fill: "#fcbeb7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M2428.27,3366.345c14.211,0,17.054,7.579,17.054,7.579,6.063,0,15.348,11.085,9.758,23.4l-.029.029-3.192,3.193v-6.821s-3.031.284-9-8.811c-2.575,3.906-23.118,10.042-39.6,7.294,0,0-.043,3.393.052,6.988v.011C2397.151,3381.4,2409.51,3366.345,2428.27,3366.345Z",
    transform: "translate(-2401.712 -3366.345)",
    fill: "#311643"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(31.531 33.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M2427.885,3397.468a1.138,1.138,0,0,0,1.137-1.137v-2.124a1.137,1.137,0,0,0-2.274,0v2.124A1.137,1.137,0,0,0,2427.885,3397.468Z",
    transform: "translate(-2426.748 -3393.07)",
    fill: "#311643"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(10.45 33.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M2411.147,3397.468a1.138,1.138,0,0,0,1.137-1.137v-2.124a1.137,1.137,0,0,0-2.274,0v2.124A1.137,1.137,0,0,0,2411.147,3397.468Z",
    transform: "translate(-2410.01 -3393.07)",
    fill: "#311643"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(22.851 47.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M2421.314,3407.937a6.5,6.5,0,0,0,4.248-1.459,5.761,5.761,0,0,0,1.511-1.873.521.521,0,0,0-.949-.429h0c-.06.128-1.5,3.151-5.686,2.667a.521.521,0,1,0-.12,1.036A8.706,8.706,0,0,0,2421.314,3407.937Z",
    transform: "translate(-2419.856 -3403.871)",
    fill: "#311643"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M2424.792,3427.6v-9.5c4.66-1.281,9.966-4.418,13.952-7.41Z",
    transform: "translate(-2395.725 -3354.841)",
    fill: "#f9afab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M2378.3,3560.209l4.3-.589,4.074-33.78h-4.231Z",
    transform: "translate(-2337.195 -3324.969)",
    fill: "#ebedf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M2460.127,3455.563",
    transform: "translate(-2315.969 -3343.2)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M2388.147,3450.631l-3.737,7.164h19.917Z",
    transform: "translate(-2335.611 -3344.479)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M2427.5,3599.651v15.423a3.256,3.256,0,0,1-3.256,3.257H2380.5a.753.753,0,0,1-.753-.754v-2.842a3.509,3.509,0,0,1,2.047-3.189l25.294-11.894Z",
    transform: "translate(-2336.82 -3305.821)",
    fill: "#2f3d6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M2422.163,3592.684l-.011,8.775h-20.4l-1.411-8.775Z",
    transform: "translate(-2331.479 -3307.628)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M2434.535,3417l-27.7,12.512a18.166,18.166,0,0,0-8.774,8.441l-10.684,21.4,16.18,7.164-1.342,47.3h80.628l-3.52-44.179,14.581.095v-24.172a18.556,18.556,0,0,0-11.408-17.124L2455.1,3417S2443.136,3424.856,2434.535,3417Z",
    transform: "translate(-2334.842 -3353.204)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(93.065 65.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M2419.558,3419.529a24.159,24.159,0,0,0,15.61,5.659,25.02,25.02,0,0,0,16.546-6.466l-.88-.368a24,24,0,0,1-15.666,6,23.339,23.339,0,0,1-14.751-5.2Z",
    transform: "translate(-2419.558 -3418.354)",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M2393.418,3599.651v15.423a3.257,3.257,0,0,1-3.257,3.257h-43.745a.754.754,0,0,1-.753-.754v-2.842a3.509,3.509,0,0,1,2.047-3.189l25.3-11.894Z",
    transform: "translate(-2345.663 -3305.821)",
    fill: "#2f3d6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M2388.077,3592.684l-.011,8.775h-20.4l-1.411-8.775Z",
    transform: "translate(-2340.322 -3307.628)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M2448.761,3493.879v.825a37.5,37.5,0,0,1-37.5,37.523H2393.85l-2.411,86.089h-21.825l-16.091-102.646a18.869,18.869,0,0,1,18.64-21.792Z",
    transform: "translate(-2343.684 -3333.26)",
    fill: "#333663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M2387.869,3508.577l-2.374,19.837h14.291Z",
    transform: "translate(-2335.33 -3329.447)",
    fill: "#4a5ea3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M2482.849,3493.879v.825a37.494,37.494,0,0,1-37.5,37.523h-17.417l-2.411,86.089H2403.7L2387.61,3515.67a18.869,18.869,0,0,1,18.641-21.792Z",
    transform: "translate(-2334.842 -3333.26)",
    fill: "#333663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M2485.131,3458.905l-.776,26.792a13.391,13.391,0,0,1-13.384,13h-46.637l-3.131-10.908,41.138-6.781.291-22.251Z",
    transform: "translate(-2326.067 -3342.371)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M2455.4,3458.76,2449.083,3482l6.025-.993.291-22.251",
    transform: "translate(-2318.834 -3342.371)",
    fill: "#4a62d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M2426.95,3481.059l7.352,11.855h-9.968l-3.131-10.908Z",
    transform: "translate(-2326.067 -3336.586)",
    fill: "#f9afab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M2363.327,3456.319h60.812a5.794,5.794,0,0,1,5.569,4.195l11.143,38.818h24.659a2.146,2.146,0,1,1,0,4.291h-96.3l-11.457-39.911A5.794,5.794,0,0,1,2363.327,3456.319Z",
    transform: "translate(-2342.585 -3343.004)",
    fill: "#4a5ea3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 2.257,
    cy: 3.295,
    rx: 2.257,
    ry: 3.295,
    transform: "matrix(0.996, -0.088, 0.088, 0.996, 51.605, 135.42)",
    fill: "#89aeff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(2121.774 3397.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M2303.052,3476.869l-21.347,172.6h-4.239l21.347-172.6Z",
    transform: "translate(-2064.908 -3338.391)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(72.163 83.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M2228.492,3528.849l-12.922,107.13h-4.238l12.921-107.13Z",
    transform: "translate(-2154.228 -3408.466)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M2183.15,3528.848,2181.7,3540.9l-11.468,95.083h-4.239l11.525-95.553,1.4-11.578Z",
    transform: "translate(-2165.99 -3408.466)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M2228.492,3635.979h-4.239l-1.787-14.817-2.119-17.567-6.97-57.785-2.046-16.962h4.239l2.1,17.446,4.792,39.73,2.119,17.567Z",
    transform: "translate(-2154.228 -3408.466)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M2273.833,3635.979h-4.239l-10.029-83.152h0l-2.891-23.979h4.239l2.948,24.442Z",
    transform: "translate(-2142.465 -3408.466)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(13.128 48.768)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 4.239,
    height: 64.803,
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 4.238,
    height: 64.803,
    transform: "translate(57.59)",
    fill: "#d2dcff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M2273.445,3523.44h-58.229a3.406,3.406,0,0,1,3.405,3.405h0a3.405,3.405,0,0,1-3.405,3.405h58.229a3.405,3.405,0,0,0,3.406-3.405h0A3.406,3.406,0,0,0,2273.445,3523.44Z",
    transform: "translate(-2153.22 -3409.869)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M2229.679,3526.845h0a3.406,3.406,0,0,0-3.405-3.405H2176a3.405,3.405,0,0,0-3.406,3.405h0a3.4,3.4,0,0,0,3.406,3.405h50.276A3.405,3.405,0,0,0,2229.679,3526.845Z",
    transform: "translate(-2164.277 -3409.869)",
    fill: "#86a2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 78.246,
    height: 48.768,
    rx: 5.112,
    transform: "translate(4.919)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M2180.776,3528.848l-1.453,12.049-4.181-.471,1.4-11.578Z",
    transform: "translate(-2163.616 -3408.466)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M2215.57,3528.848l2.1,17.446-4.3-.484-2.045-16.962Z",
    transform: "translate(-2154.227 -3408.466)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M2263.859,3553.29l-4.293-.462h0l-2.891-23.979h4.239Z",
    transform: "translate(-2142.465 -3408.466)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M2176.414,3471.985h4.239v8.95l-4.239-.469Z",
    transform: "translate(-2163.286 -3423.217)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M2226.379,3471.985v15.325l-4.237-.469v-14.856Z",
    transform: "translate(-2151.423 -3423.217)",
    fill: "#aec3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(74.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(25.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M2241.742,3381.687c-4.981,8.238-20.2,20.092-42.831,12.857h0a1.484,1.484,0,0,0-.216-.018c-5.383,0-5.759,14.974,3.3,15.839q.2.66.41,1.248v24.35h20.437V3426.5a15.108,15.108,0,0,0,4.04.632c8.453,0,23.148-13.04,23.483-33.583C2248.1,3393.041,2241.742,3387.435,2241.742,3381.687Z",
    transform: "translate(-2186.401 -3363.083)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M2255.5,3391.408c0-13.531-11.933-24.493-29.827-24.493-14.871,0-19.982,8.207-19.982,8.207s-14.056,3.038-14.056,20.5V3439.8h59.874V3403.42A18.836,18.836,0,0,0,2255.5,3391.408Zm-27.775,39.557a15.108,15.108,0,0,1-4.04-.632v9.464h-20.437v-24.35q-.21-.587-.41-1.248c-9.06-.865-8.684-15.839-3.3-15.839a1.484,1.484,0,0,1,.216.018h0c22.632,7.234,37.85-4.619,42.831-12.857,0,5.748,6.361,11.354,8.625,11.864C2250.872,3417.925,2236.177,3430.965,2227.724,3430.965Z",
    transform: "translate(-2187.241 -3366.915)",
    fill: "#311643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M2188.146,3424.887l16.007-7.416,8.784.232,11.652.55,16.746,5.085V3444.7h-53.189Z",
    transform: "translate(-2188.146 -3353.8)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(32.127 33.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(20.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M2231.114,3398.171a1.128,1.128,0,0,1-1.127-1.127v-2.107a1.128,1.128,0,0,1,2.256,0v2.107A1.128,1.128,0,0,1,2231.114,3398.171Z",
    transform: "translate(-2229.987 -3393.809)",
    fill: "#311643"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M2214.782,3398.171a1.128,1.128,0,0,1-1.127-1.127v-2.107a1.128,1.128,0,0,1,2.256,0v2.107A1.128,1.128,0,0,1,2214.782,3398.171Z",
    transform: "translate(-2213.655 -3393.809)",
    fill: "#311643"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(35.545 47.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M2222.128,3408.736a6.451,6.451,0,0,1-4.214-1.446,5.735,5.735,0,0,1-1.5-1.857.517.517,0,0,1,.941-.427h0c.059.128,1.488,3.125,5.641,2.646a.517.517,0,1,1,.118,1.026A8.784,8.784,0,0,1,2222.128,3408.736Z",
    transform: "translate(-2216.37 -3404.703)",
    fill: "#311643"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M2266.087,3609.712l-18.748-8.059.961,4.645-23.061-7.242v6.608a6.6,6.6,0,0,0,3.126,5.613l1.982,5.67a1.223,1.223,0,0,0,1.154.819h0a1.221,1.221,0,0,0,1.222-1.222v-3.687l15.762,4.91h15.944a4.2,4.2,0,0,0,4.2-4.2h0A4.2,4.2,0,0,0,2266.087,3609.712Z",
    transform: "translate(-2153.121 -3306.693)",
    fill: "#2f3d6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M2298.547,3609.712l-18.747-8.059.961,4.645-23.062-7.242v6.608a6.6,6.6,0,0,0,3.126,5.613l1.984,5.67a1.221,1.221,0,0,0,2.374-.4v-3.687l15.763,4.91h15.944a4.2,4.2,0,0,0,4.2-4.2h0A4.2,4.2,0,0,0,2298.547,3609.712Z",
    transform: "translate(-2144.7 -3306.693)",
    fill: "#2f3d6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M2225.239,3592.078l.011,8.789,23.051,7.242-.961-4.646-1.915-.978,1.674-10.408Z",
    transform: "translate(-2153.121 -3308.504)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M2257.7,3592.078l.011,8.789,23.051,7.242-.961-4.646-1.915-.975,1.674-10.411Z",
    transform: "translate(-2144.7 -3308.504)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M2212.109,3493.11v.826a37.556,37.556,0,0,0,37.556,37.584h17.448l2.413,86.23h21.86l16.119-102.814a18.9,18.9,0,0,0-18.672-21.827Z",
    transform: "translate(-2156.527 -3334.177)",
    fill: "#333663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M2254.938,3515.561l1.5,10.136h-3.184Z",
    transform: "translate(-2145.853 -3328.354)",
    fill: "#4a5ea3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M2184.9,3511.864h0a24.855,24.855,0,0,0,24.765,22.746h23.652l2.414,86.23h21.86l15.948-101.727a19.84,19.84,0,0,0-19.6-22.914h-1.75l-5.019-15h-57.582l-4.378,24.116A24.845,24.845,0,0,0,2184.9,3511.864Z",
    transform: "translate(-2163.61 -3337.267)",
    fill: "#333663"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(0 66.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M2214.256,3432.989c3.881,0,6.986-3.738,9.079-7.523H2201.2C2204.577,3429.241,2209.2,3432.989,2214.256,3432.989Z",
    transform: "translate(-2159.357 -3417.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M2264.475,3435.158l-1.531-2.384a19.834,19.834,0,0,0-10.907-8.252l-17.055-5.194a27.648,27.648,0,0,1-3.028,7.729c-2.093,3.786-5.2,7.523-9.079,7.523-5.056,0-9.679-3.748-13.056-7.523a47.654,47.654,0,0,1-5.565-7.69l-15.24,7.061a22.711,22.711,0,0,0-12.49,15.125l-6.793,21.708a38.481,38.481,0,0,0-1.754,11.478v1.8a8.448,8.448,0,0,0,8.449,8.448h16.248l1.278,12.269h57.582l14.513-59.651Z",
    transform: "translate(-2167.976 -3419.328)",
    fill: "#d2dcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(31.483 67.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M2216.958,3439.732a18.874,18.874,0,0,1-9.682-2.9,34.609,34.609,0,0,1-7.562-6.309,52.418,52.418,0,0,1-6.74-9.175l.856-.4a51.05,51.05,0,0,0,6.588,8.948,33.612,33.612,0,0,0,7.347,6.13,17.95,17.95,0,0,0,9.193,2.758,11.547,11.547,0,0,0,7.647-2.833,19.256,19.256,0,0,0,4.677-6.33,35.741,35.741,0,0,0,2.945-9.4l.934.285a35.889,35.889,0,0,1-3.024,9.509,20.235,20.235,0,0,1-4.915,6.646A12.461,12.461,0,0,1,2216.958,3439.732Z",
    transform: "translate(-2192.974 -3420.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M2175.574,3474.59h63.183v-7.975l-62.314-7.17a7.6,7.6,0,0,0-8.466,7.548h0A7.6,7.6,0,0,0,2175.574,3474.59Z",
    transform: "translate(-2167.976 -3342.924)",
    fill: "#fcbeb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M2309.212,3433.838h-64.557a5.8,5.8,0,0,0-5.578,4.2l-11.162,38.881h-24.648a2.183,2.183,0,0,0-2.2,2.07,2.148,2.148,0,0,0,2.147,2.228h96.455l12.481-43.479A3.058,3.058,0,0,0,2309.212,3433.838Z",
    transform: "translate(-2159.392 -3349.554)",
    fill: "#4a5ea3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 3.3,
    cy: 2.261,
    rx: 3.3,
    ry: 2.261,
    transform: "matrix(0.088, -0.996, 0.996, 0.088, 110.182, 112.604)",
    fill: "#2f3d6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M2189.075,3481.2l-2.3,12.689,61.21-8.733-1.324-3.956Z",
    transform: "translate(-2163.1 -3337.267)",
    fill: "#4a5ea3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(0 138.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M2134.277,3476.869l-5.711,46.177-15.636,126.418h-4.239l15.592-126.057,5.756-46.539Z",
    transform: "translate(-2108.692 -3476.869)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M2178.816,3649.465h-4.239l-16.069-129.918-5.279-42.678h4.239l5.235,42.324Z",
    transform: "translate(-2097.138 -3476.869)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M2126.827,3476.869h4.239l-5.711,46.177-4.283.361Z",
    transform: "translate(-2105.48 -3476.869)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M2157.468,3476.869l5.235,42.324-4.195.354-5.279-42.678Z",
    transform: "translate(-2097.138 -3476.869)",
    fill: "#aec3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(268.651 138.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M2347.591,3649.465h-4.239l-18.262-147.658L2322,3476.869h4.238l3.041,24.583Z",
    transform: "translate(-2322.005 -3476.869)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M2329.284,3501.452l-4.194.354L2322,3476.869h4.238Z",
    transform: "translate(-2322.005 -3476.869)",
    fill: "#aec3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(7.78 131.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M2378.815,3471.46H2162.653v6.812h216.162a3.406,3.406,0,0,0,3.405-3.406h0A3.406,3.406,0,0,0,2378.815,3471.46Z",
    transform: "translate(-2102.473 -3471.46)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M2131.049,3471.46h-12.773a3.406,3.406,0,0,0-3.407,3.406h0a3.407,3.407,0,0,0,3.407,3.406h56.773v-6.812Z",
    transform: "translate(-2114.869 -3471.46)",
    fill: "#86a2e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(234.319 111.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M2339.686,3465.973v-1.735a.972.972,0,0,0-.972-.972h-40.288a3.681,3.681,0,0,0-3.681,3.68h0v2.961h0a3.68,3.68,0,0,0,3.681,3.68h40.288a.972.972,0,0,0,.972-.972v-1.735a.972.972,0,0,0-.972-.972h-38.808a1.481,1.481,0,0,1-1.48-1.481h0a1.48,1.48,0,0,1,1.48-1.479h38.808A.973.973,0,0,0,2339.686,3465.973Z",
    transform: "translate(-2294.745 -3452.943)",
    fill: "#6277d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M2337.188,3466.187v2.961h-38.04a1.481,1.481,0,0,1-1.48-1.481h0a1.48,1.48,0,0,1,1.48-1.479Z",
    transform: "translate(-2293.987 -3452.185)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M2336.214,3457.778v-1.737a.972.972,0,0,0-.972-.972h-34.531a3.68,3.68,0,0,0-3.68,3.68h0v2.961h0a3.679,3.679,0,0,0,3.68,3.68h34.531a.971.971,0,0,0,.972-.971v-1.736a.972.972,0,0,0-.972-.972h-33.05a1.48,1.48,0,0,1-1.481-1.48h0a1.481,1.481,0,0,1,1.481-1.481h33.05A.971.971,0,0,0,2336.214,3457.778Z",
    transform: "translate(-2294.152 -3455.069)",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M2334.177,3457.991v2.961h-32.742a1.48,1.48,0,0,1-1.481-1.48h0a1.481,1.481,0,0,1,1.481-1.481Z",
    transform: "translate(-2293.394 -3454.311)",
    fill: "#d2dcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(40.59 99.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M2143.105,3458.309h19.012a1.565,1.565,0,0,1,1.553,1.75l-1.608,13.434a1.564,1.564,0,0,1-1.553,1.378h-15.8a1.564,1.564,0,0,1-1.553-1.378l-1.608-13.434A1.565,1.565,0,0,1,2143.105,3458.309Z",
    transform: "translate(-2140.759 -3442.385)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M2159.3,3456.107V3450l-3.655,6.944v-11.278l-2.872,7.1-2.872-7.1v11.278l-3.655-6.944v6.109l-5.326-8.563,2.346,14.045h19.011l2.347-14.045Z",
    transform: "translate(-2140.92 -3445.665)",
    fill: "#91ffe7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(2602.89 3561.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M2530.324,3528.627l-2.831,23.489-3.4,28.2-2.139,17.732-.728,6.013-2.139,17.736-1.8,14.954H2513l3.947-32.686,2.135-17.736.727-6.014,2.139-17.732v0l1.419-11.767,2.675-22.19Z",
    transform: "translate(-2484.921 -3488.96)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M2553.077,3636.755H2548.8l-9.532-79.045-3.51-29.083h4.278l3.678,30.486Z",
    transform: "translate(-2479.018 -3488.96)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M2508.025,3528.627l-1.8,14.938-7.3,60.5-2.139,17.736-1.8,14.954h-4.278l3.942-32.686,2.139-17.736,5.318-44.073,1.643-13.634Z",
    transform: "translate(-2490.705 -3488.96)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M2530.778,3636.755H2526.5l-4.666-38.7-2.139-17.732-3.842-31.846-2.4-19.847h4.278l2.567,21.254,1.531,12.7v0l2.139,17.732Z",
    transform: "translate(-2484.803 -3488.96)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 62.191,
    height: 6.875,
    rx: 2.652,
    transform: "translate(5.055 32.79)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 35.423,
    height: 6.875,
    rx: 2.652,
    transform: "translate(5.055 32.79)",
    fill: "#86a2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M2512.116,3509.893H2531.3a1.579,1.579,0,0,1,1.568,1.767l-1.624,13.559a1.579,1.579,0,0,1-1.568,1.392H2513.74a1.581,1.581,0,0,1-1.568-1.392l-1.623-13.559A1.58,1.58,0,0,1,2512.116,3509.893Z",
    transform: "translate(-2485.561 -3493.82)",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M2528.461,3507.671V3501.5l-3.689,7.009v-11.383l-2.9,7.167-2.9-7.167v11.383l-3.689-7.009v6.166l-5.375-8.643,2.368,14.176h19.189l2.368-14.176Z",
    transform: "translate(-2485.723 -3497.131)",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M2505.677,3528.627l-1.8,14.938-4.118-1.3,1.643-13.634Z",
    transform: "translate(-2488.358 -3488.96)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M2520.3,3549.881l-4.45-1.407-2.4-19.847h4.278Z",
    transform: "translate(-2484.803 -3488.96)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M2528.189,3528.627l-2.831,23.489-4.122-1.3,2.675-22.19Z",
    transform: "translate(-2482.785 -3488.96)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M2543.713,3559.113l-4.446-1.4-3.51-29.083h4.278Z",
    transform: "translate(-2479.018 -3488.96)",
    fill: "#aec3ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(-2052.854 -2058.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M2470.057,2903.588c11.875-21.743-25.614-31.968-34.651-23.343S2456.33,2928.72,2470.057,2903.588Z",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M2485.818,2896.951c23.3,0,12.758-41.684,2.794-41.684C2476.12,2855.267,2458.892,2896.951,2485.818,2896.951Z",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M2503.781,2912.071c19.213,15.641,36.1-19.355,29.269-29.814S2481.572,2893.993,2503.781,2912.071Z",
    fill: "#91ffe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M2479.279,2922.421a69.167,69.167,0,0,0-14.108-20.78,79.652,79.652,0,0,0-21.467-15.753.648.648,0,0,0-.533,1.18,78.338,78.338,0,0,1,21.1,15.51,67.848,67.848,0,0,1,13.826,20.383c.36.834.695,1.678,1.017,2.526h1.385C2480.121,2924.456,2479.716,2923.433,2479.279,2922.421Z",
    fill: "#6de3c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M2488.033,2863.815a.647.647,0,1,0-1.286-.153,566.4,566.4,0,0,0-3.143,61.825h1.295A565.164,565.164,0,0,1,2488.033,2863.815Z",
    fill: "#6de3c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M2526.577,2886.94a.647.647,0,0,0-.9-.179,122.251,122.251,0,0,0-19.058,16.692,94.453,94.453,0,0,0-15.554,22.034h1.448a93.716,93.716,0,0,1,15.034-21.13,120.875,120.875,0,0,1,18.85-16.519A.647.647,0,0,0,2526.577,2886.94Z",
    fill: "#6de3c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M2484.9,2925.487h-23.858a1.023,1.023,0,0,0-.973,1.339l1.142,3.5.577,1.772,8.262,25.346a1.671,1.671,0,0,0,1.589,1.154h29.777a1.67,1.67,0,0,0,1.589-1.154l8.262-25.346.577-1.772,1.142-3.5a1.022,1.022,0,0,0-.973-1.339H2484.9Z",
    fill: "#d2dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M2511.843,2930.327l-.577,1.772h-49.479l-.577-1.772Z",
    fill: "#86a2e2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.32eb9189bd83bde765ed42bca4446103.svg";
export { ForwardRef as ReactComponent };